var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.002,
    height: 35.999,
    viewBox: "0 0 36.002 35.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-clock",
    "data-name": "Icon ionic-ios-clock",
    d: "M34.1,8.645a18,18,0,1,0,0,25.459A18.009,18.009,0,0,0,34.1,8.645ZM6.975,22.049a.692.692,0,1,1,.545-.545A.692.692,0,0,1,6.975,22.049Zm2.267,7.113a.69.69,0,1,1,.2-.736A.691.691,0,0,1,9.243,29.163Zm.2-14.841a.688.688,0,1,1-.2-.736A.692.692,0,0,1,9.442,14.322Zm5.322,19.86a.688.688,0,1,1-.2-.736A.692.692,0,0,1,14.764,34.182ZM14.565,9.3a.69.69,0,1,1,.2-.736A.691.691,0,0,1,14.565,9.3Zm3.063,6.6a.693.693,0,1,1,1.186-.718l2.916,5.391a2.8,2.8,0,0,1,.337,1.315V32.451a.692.692,0,0,1-1.385,0V21.894a1.424,1.424,0,0,0-.164-.658Zm3.885,20.682a.692.692,0,1,1,.545-.545A.692.692,0,0,1,21.513,36.587Zm0-29.076a.692.692,0,1,1,.545-.545A.692.692,0,0,1,21.513,7.511ZM29.1,34.485a.69.69,0,1,1,.2-.736A.691.691,0,0,1,29.1,34.485ZM29.3,9a.688.688,0,1,1-.2-.736A.692.692,0,0,1,29.3,9Zm5.322,19.86a.688.688,0,1,1-.2-.736A.692.692,0,0,1,34.624,28.86Zm-.2-14.235a.69.69,0,1,1,.2-.736A.691.691,0,0,1,34.425,14.625Zm1.627,7.425A.692.692,0,1,1,36.6,21.5.692.692,0,0,1,36.051,22.049Z",
    transform: "translate(-3.372 -3.375)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.42dc2b55.svg";
export { ForwardRef as ReactComponent };